import gql from 'graphql-tag'
import { interceptGraphQLErrors } from './utils'

export function getEmailHandler({ apolloClient }, { email }) {
  return apolloClient
    .query({
      query: gql`
        query getEmailHandler($email: String!) {
          getEmailHandler(email: $email) {
            handler
          }
        }
      `,
      variables: { email },
    })
    .then(interceptGraphQLErrors)
    .then((response) => response.data.getEmailHandler)
}

export async function cancelSignupReminders({ apiUrl }, email) {
  await fetch(`${apiUrl}/auth/cancel-signup-reminders`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      data: {
        attributes: {
          email,
        },
      },
    }),
  })
}
